import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X, ArrowUpRight } from "lucide-react";

const links = [
  { to: "/", label: "Home" },
  { to: "/services", label: "Services" },
  { to: "/industries", label: "Industries" },
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" },
];

export default function Nav() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 border-b border-white/[0.08] bg-ink/80 backdrop-blur-md" data-testid="site-nav">
      <div className="mx-auto flex h-[72px] max-w-7xl items-center justify-between px-5 sm:px-8">
        <Link to="/" className="group flex items-center" data-testid="nav-logo" onClick={() => setOpen(false)}>
          <img src="/apx-logo-dark.png" alt="APX Project Solutions" className="h-11 w-auto transition-opacity group-hover:opacity-80" />
        </Link>

        <nav className="hidden items-center gap-8 lg:flex" data-testid="nav-links-desktop">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className={({ isActive }) =>
                `font-mono text-xs uppercase tracking-[0.22em] transition-colors ${
                  isActive ? "text-apx" : "text-zinc-400 hover:text-white"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
          <a
            href="mailto:APX@apxproject.com"
            data-testid="nav-email-cta"
            className="chamfer-sm group inline-flex items-center gap-2 bg-apx px-5 py-2.5 font-mono text-xs font-bold uppercase tracking-[0.15em] text-ink transition-colors hover:bg-white"
          >
            Email APX
            <ArrowUpRight className="h-3.5 w-3.5 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </a>
        </nav>

        <button
          className="text-white lg:hidden"
          onClick={() => setOpen(!open)}
          data-testid="nav-mobile-toggle"
          aria-label="Toggle menu"
        >
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>

      {open && (
        <nav className="border-t border-white/[0.08] bg-ink px-5 py-6 lg:hidden" data-testid="nav-links-mobile">
          <div className="flex flex-col gap-5">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                onClick={() => setOpen(false)}
                data-testid={`nav-mobile-link-${l.label.toLowerCase()}`}
                className={({ isActive }) =>
                  `font-display text-2xl font-bold uppercase tracking-wide ${isActive ? "text-apx" : "text-zinc-300"}`
                }
              >
                {l.label}
              </NavLink>
            ))}
            <a
              href="mailto:APX@apxproject.com"
              data-testid="nav-mobile-email-cta"
              className="chamfer-sm mt-2 inline-flex w-fit items-center gap-2 bg-apx px-5 py-3 font-mono text-xs font-bold uppercase tracking-[0.15em] text-ink"
            >
              Email APX <ArrowUpRight className="h-3.5 w-3.5" />
            </a>
          </div>
        </nav>
      )}
    </header>
  );
}
